export const DnDTypes = {
    EVENT: 'event',
};
